import React, {useState} from 'react';

type PropTypes = {
  children: Node,
};

const FakeChevron = ({children}: PropTypes) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}} onClick={() => setOpen(!isOpen)}>
      <span
        style={{margin: '3px 8px 0 0', fontSize: '14px', color: '#3d4c59'}}
        className={isOpen ? 'icn-arrow16-chevrondown' : 'icn-arrow16-chevronright'}
      />
      {children}
    </div>
  );
};

export default FakeChevron;
